import { queryOptions, useQuery } from '@tanstack/react-query';
import { customFetch } from '~/utils/customFetch';

import {
  staffStatColumnMetadataListSchema,
  type StaffStatColumnMetadataList,
  type StaffStatColumnMetadataRow,
} from './staffStatColumnMetadataSchema';

export type { StaffStatColumnMetadataRow } from './staffStatColumnMetadataSchema';

const fetchStaffStatColumnMetadata = async (): Promise<StaffStatColumnMetadataList> => {
  const { data } = await customFetch.get<unknown>(
    '/authenticated/staff/analytics/column-metadata',
    {
      headers: { 'Content-Type': 'application/json' },
      useNodeEndpoint: true,
    },
  );
  return staffStatColumnMetadataListSchema.parse(data);
};

export const getStaffStatColumnMetadataQueryOptions = () =>
  queryOptions({
    queryKey: ['staff', 'stat-column-metadata'],
    queryFn: fetchStaffStatColumnMetadata,
    staleTime: 60 * 1000,
    refetchOnWindowFocus: false,
  });

export const useStaffStatColumnMetadataQuery = () =>
  useQuery(getStaffStatColumnMetadataQueryOptions());
